export { MyParcelsRightSection } from './MyParcelsRightSection';
